// extracted by mini-css-extract-plugin
export var swiper = "we-module--swiper--2QW9Q";
export var weBackground = "we-module--we-background--2lthX";
export var dimmed = "we-module--dimmed--3WLkB";
export var slideContent = "we-module--slide-content--ycAJM";
export var slideTitle = "we-module--slide-title--3bQjj";
export var slideSummary = "we-module--slide-summary--KgvT3";
export var slideSummaryEng = "we-module--slide-summary-eng--3CJY0";